import i18n from '@/i18n'
import store from '@/store'
import { removeCookie } from '@/utils/cookies'
export default function () {
  return {
    resetI18nSetting() {
      i18n.locale = 'fr'
      store.state.settings.applicationLanguage = ''
      removeCookie('locale')
    },
  }
}
